/**
 * To get a 48×48 pixel spinner, use {{spinner}}. This takes an argument size: {{spinner size=32}}
 */
export default function(options) {
    var size = options.hash && options.hash.size || 48;
    return new Handlebars.SafeString(Beef.Ui.Spinner.renderSpinner(size));
}